import './ImportModal.scss';
import { ChangeEvent, ReactElement, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '../Button';
import { BPMFileInput } from '../BPMFileInput/BPMFileInput';

interface ImportModalProps {
  file?: File;
  setFile: (file?: File) => void;
  importFunction: () => void | Promise<void>;
  onClose: () => void;
  subtitle?: string | ReactElement;
}

export const ImportModal = ({
  file,
  setFile,
  importFunction,
  onClose,
  subtitle
}: ImportModalProps) => {
  const [importing, setImporting] = useState(false);

  const modalImport = async () => {
    setImporting(true);
    try {
      await importFunction();
      onClose();
    } catch {
      // Import failed; keep the modal open and let the dispatched error surface.
    } finally {
      setImporting(false);
    }
  };

  return (
    <Modal show onHide={onClose} contentClassName='import-modal'>
      <Modal.Header closeButton>
        <Modal.Title>Import Changes (from Excel)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='import-modal-body'>
          <BPMFileInput
            id='importModalFileInput'
            name='importModalFileInput'
            onChange={(e: ChangeEvent<HTMLInputElement>) => setFile(e.target.files?.[0])}
          />
          <div>{file ? file.name : 'No File Selected'}</div>
        </div>
        {subtitle && <div className='import-modal-subtitle'>{subtitle}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={!file} loading={importing} onClick={modalImport}>
          Import
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
